<template>
  <!-- 主页 -->
  <div class="footer" v-if="!isNews">
    <div class="footerMain clearfix">
      <img class="lf" :src="picUrl + '/img/home/twoCode.png'" alt="" />
      <a class="banben" href="https://beian.miit.gov.cn/" target="_blank"
        >浙ICP备19020141号-1</a
      >
      <div class="rt">
        <ul class="navul clearfix">
          <li>
            <p class="title" @click="goto(2, 1)">关于大蔚</p>
            <p class="te" @click="goto(2, 1)">公司简介</p>
            <p class="te" @click="goto(2, 2)">团队风采</p>
            <p class="te" @click="goto(2, 3)">公司荣誉</p>
            <p class="te" @click="goto(2, 4)">企业文化</p>
            <p class="te" @click="goto(2, 5)">大事记</p>
            <p class="te" @click="goto(2, 6)">团队风采</p>
          </li>
          <li>
            <p class="title" @click="goto(3, 1)">解决方案</p>
            <p class="te" @click="goto(3, 1)">前端分类</p>
            <p class="te" @click="goto(3, 2)">易腐处理</p>
            <p class="te" @click="goto(3, 3)">资源利用</p>
            <p class="te" @click="goto(3, 4)">数字赋能</p>
          </li>
          <li>
            <p class="title" @click="goto(4, 1)">项目案例</p>
            <p class="te" @click="goto(4, 1)">前端分类案例</p>
            <p class="te" @click="goto(4, 2)">易腐处理案例</p>
            <p class="te" @click="goto(4, 3)">资源利用案例</p>
            <p class="te" @click="goto(4, 4)">数字赋能案例</p>
          </li>
          <li>
            <p class="title" @click="goto(5, 1)">新闻资讯</p>
            <p class="te" @click="goto(5, 1)">视频中心</p>
            <p class="te" @click="goto(5, 2)">企业动态</p>
          </li>

          <li @click="goto(6)">
            <p class="title">联系我们</p>
            <p class="te">联系方式</p>
            <p class="te">在线留言</p>
          </li>
          <li @click="goto(7)">
            <p class="title">人才中心</p>
            <!-- <p class="te">人才招聘</p> -->
            <!-- <p class="te">简历投递</p> -->
          </li>
          <li style="margin-right: 0" @click="goto(8)">
            <p class="title">友情链接</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import eventbus from "../../src/components/eventbus.vue";
import { picUrl } from "@/config/env";

export default {
  name: "mineheader",
  data() {
    return {
      picUrl: "",
      isNews: false,
    };
  },
  inject: ["reload"],
  components: { picUrl },
  watch: {
    $route(newRoute) {
      if (newRoute.name == "news") {
        this.isNews = true;
      } else {
        this.isNews = false;
      }
    },
  },
  computed: {},
  mounted() {
    let newRoute = this.$router.history.current.name;
    if (newRoute == "news") {
      this.isNews = true;
    } else {
      this.isNews = false;
    }
    this.$nextTick(() => {
      this.picUrl = picUrl;
    });
  },
  methods: {
    goto(i, j) {
      let arr = [
        "/home",
        "/aboutus",
        "/solution",
        "/projectcase",
        "/news",
        "/contactus",
        "/joinus",
        "/minelink",
      ];
      //配色判断
      eventbus.$emit("myfn", i);

      this.$router.push(arr[i - 1]);
      window.scroll(0, 0);
      return;
    },
  },
};
</script>

<style scoped>
.footer {
  background: #f5f5f5;
  padding: 73px 0 40px 0;
}
.footerMain {
  width: 83%;
  max-width: 1600px;
  margin: 0 auto;
  position: relative;
}
.lf {
  width: 450px;
  height: 220px;
  float: left;
}
.rt {
  float: right;
}

@media (max-width: 1024px) {
  .rt {
    display: none;
  }
}
ul,
li {
  list-style: none;
}

.navul li {
  margin-right: 40px;
  float: left;
}

.title {
  font-size: 24px;
  color: #333333;
  font-weight: 400;
  font-family: Source Han Sans CN;
  margin-bottom: 22px;
}
.te {
  font-size: 18px;
  margin-bottom: 13px;
  color: #999;
  transition: all 0.3s;
}
.te:hover {
  color: #409eff;
  cursor: pointer;
}
.banben {
  position: absolute;
  left: 0;
  bottom: 0;
}
</style>
